import React from "react";

export default function Separator({
  margin,
  hideLine = false,
  useCustomValue = false,
  customMarginTop = 0,
  customMarginBottom = 0,
}) {
  let marginClass = "my-4";
  if (margin === "medium") {
    marginClass = "my-8";
  } else {
    marginClass = "my-16";
  }

  let customMarginStyle = {
    marginTop: customMarginTop,
    marginBottom: customMarginBottom,
  };

  return (
    <div
      className={`z-50 relative mx-auto max-w-restricted ${useCustomValue ? "" : marginClass}`}
      style={useCustomValue ? customMarginStyle : null}
    >
      <hr
        className={`border-t border-solid ${hideLine ? "border-transparent" : "border-gray"}`}
      />
    </div>
  );
}
